import { formatDate } from "../../../../../api/DateUtils";
import { Column } from "react-table";
import { Grid } from "../../../../../leap-components/Grid";
import { SelectColumnFilter } from "../../../../../leap-components/Grid/NoFetchGrid/SelectColumnFilter";
import { GetFilteredDocumentsFetchUrl } from "../../../../../api/CircularEconomy/CertificateOfRegistration/ICertificateOfRegistration";
import EpaCard from "../../../../../leap-components/EpaCard";
import { Link } from "react-router-dom";

interface IDocumentRow {
  documentid: string;
  filename: string;
  url: string;
  extension: string;
  filesize: string;
  documentdate: string;
  regardingobjectid: string;
  licenceid: string;
}

interface DocumentsGridProps {
  licenseId: string;
}

const DocumentsGrid = ({ licenseId }: DocumentsGridProps) => {
  const getFetchUrlFactory = (licenseId: string) => {
    let fetchUrlFn = (
      pageNo: number,
      recordsPerPage: number,
      searchText: string,
      filters: any
    ) => {
      return GetFilteredDocumentsFetchUrl(
        licenseId,
        pageNo,
        recordsPerPage,
        searchText,
        filters
      );
    };

    return fetchUrlFn;
  };

  const fetchUrl = getFetchUrlFactory(licenseId);

  const tableColumnsBig: Column<Record<string, IDocumentRow>>[] = [
    {
      Header: "Date",
      accessor: "documentdate",
      Filter: false,
      Cell: (rowInfo: any) => formatDate(rowInfo.value),
    },
    {
      Header: "Document Name",
      accessor: "filename",
      Filter: false,
      Cell: (rowInfo: any) => {
        const rowData = rowInfo.data[rowInfo.row.index];
        return <a href={rowData.url}>{rowInfo.value}</a>;
      },
      sortType: "basic",
    },
  ];

  const tableColumnsSmall: Column<Record<string, IDocumentRow>>[] = [
    {
      Header: "Date",
      accessor: "documentdate",
      Filter: false,
      Cell: (rowInfo: any) => formatDate(rowInfo.value),
    },
    {
      Header: "Document Name",
      accessor: "filename",
      Filter: false,
      Cell: (rowInfo: any) => {
        const rowData = rowInfo.data[rowInfo.row.index];
        return <a href={rowData.url}>{rowInfo.value}</a>;
      },
      sortType: "basic",
    },
  ];

  var bodyElements = (
    <div className="ps-0">
      <div className="d-md-none">
        <Grid
          columns={tableColumnsSmall}
          data={[]}
          fetchUrlFunction={fetchUrl}
          enablePagination={true}
          enableQuickFind={false}
        />
      </div>
      <div className="d-none d-md-block">
        <Grid
          columns={tableColumnsBig}
          data={[]}
          fetchUrlFunction={fetchUrl}
          enablePagination={true}
          enableQuickFind={false}
        />
      </div>
    </div>
  );

  return <EpaCard title={"Documents"} content={bodyElements} />;
};

export { DocumentsGrid };
